<template>
  <div ref="container" style="padding:0 24px;height: 100%;">
    <el-descriptions ref="desc" size="mini" :inline="true" :colon="false" :model="yt.conditions" class="demo-form-inline" :size="100">
      <el-descriptions-item></el-descriptions-item>
      <el-descriptions-item></el-descriptions-item>
      <el-descriptions-item>
        {{ $attrs.tool.toolNo + ' | ' + $attrs.tool.toolName }}
      </el-descriptions-item>
    </el-descriptions>
    <el-tabs ref="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('chanpin')" name="first"> </el-tab-pane>
      <el-tab-pane :label="$t('muju')" name="second"> </el-tab-pane>
      <el-tab-pane :label="$t('shebei')" name="third"> </el-tab-pane>
    </el-tabs>
    <div :style="{ height: tableHeight + 'px' }">
      <tool_adapt_product :tool="$attrs.tool" v-show="activeName == 'first'" v-if="tableHeight != 0"></tool_adapt_product>
      <tool_adapt_mould :tool="$attrs.tool" v-show="activeName == 'second'" v-if="tableHeight != 0"></tool_adapt_mould>
      <tool_adapt_equipment :tool="$attrs.tool" v-show="activeName == 'third'" v-if="tableHeight != 0"></tool_adapt_equipment>
    </div>
  </div>
</template>

<script>
import tool_adapt_product from '@@/pages/web/base/tool/tool_adapt_product';
import tool_adapt_mould from '@@/pages/web/base/tool/tool_adapt_mould';
import tool_adapt_equipment from '@@/pages/web/base/tool/tool_adapt_equipment';
export default {
  name: "web_base_tool_tool_adapt_index",
  components: {
    tool_adapt_product,
    tool_adapt_mould,
    tool_adapt_equipment,
  },
  data() {
    return {
      activeName: "first",
      tableHeight: 0,
    };
  },
  created() {},

  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },

  methods: {
    resize() {
      this.$nextTick(() => {
        this.tableHeight = this.$refs.container.offsetHeight - 40 - 33 - 14;
      });
    },
    handleClick(tab) {
      this.utils.event_hub.$emit("RESIZE");
    },
  },
}
</script>

<style scoped lang="scss">

</style>